var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"services"}},[_vm._v("\n\tMatthias"),_c('br'),_vm._v("schreibt"),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.service)}}),_vm._v(".\n")])}
var staticRenderFns = []

export { render, staticRenderFns }